import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import Cookies from "js-cookie";
import { debounce } from "../utils/functions";

const $document = $(document);
let studyProgramBlockEl = $('.study-program-block-main');
let filter = {};

$(function () {
    if (studyProgramBlockEl.length > 0) {
        studyProgramBlockEl.each(function () {
            studyProgramBlock($(this));
        });
    }
});


  // =============  DATALAYERS  ============

  // Function to generate a unique user hash
  const generateUserHash = () => {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);
    return Array.from(array, (byte) =>
      ("0" + byte.toString(16)).slice(-2)
    ).join("");
  };

  // Check if the user hash cookie is already set
  let userHash = Cookies.get("user_hash");
  if (!userHash) {
    // Generate a new user hash and set it in the cookie
    userHash = generateUserHash();
    Cookies.set("user_hash", userHash, { expires: 1 }); // Cookie expires in 1 day
  }

  // Function to push data to the data layer
  const pushToDataLayer = (eventName, additionalData = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...additionalData,
    });
  };

  // Add event listener to the search field
  $document.on(
    "input",
    'input[name="studyProgram-search"]',
    debounce(
      function (event) {
        const keyword = $(this).val();
        pushToDataLayer("mendel_search", {
          keyword: keyword,
          user_hash: userHash,
        });
      },
      false,
      3000
    )
  );

  $document.on("keyup", 'input[name="studyProgram-search"]', function (event) {
    if (event.key === "Enter") {
      const keyword = $(this).val();
      pushToDataLayer("mendel_search", {
        keyword: keyword,
        user_hash: userHash,
      });
    }
  });

  // Add event listeners to the first set of radio buttons (mendel_degree)
  $document.on(
    "change",
    'input[name="studyProgram-type"]',
    debounce(
      function (event) {
        pushToDataLayer("mendel_degree", {
          degree: $(this).val(),
          user_hash: userHash,
        });
      },
      false,
      3000
    )
  );

  $document.on("keyup", 'input[name="studyProgram-type"]', function (event) {
    if (event.key === "Enter") {
      pushToDataLayer("mendel_degree", {
        degree: $(this).val(),
        user_hash: userHash,
      });
    }
  });

  // Add event listeners to the second set of radio buttons (mendel_language)
  $document.on(
    "change",
    'input[name="studyProgram-language"]',
    debounce(
      function (event) {
        pushToDataLayer("mendel_language", {
          language: $(this).val(),
          user_hash: userHash,
        });
      },
      false,
      3000
    )
  );

  $document.on(
    "keyup",
    'input[name="studyProgram-language"]',
    function (event) {
      if (event.key === "Enter") {
        pushToDataLayer("mendel_language", {
          language: $(this).val(),
          user_hash: userHash,
        });
      }
    }
  );

  // Add event listeners to the third set of radio buttons (mendel_form)
  $document.on(
    "change",
    'input[name="studyProgram-form"]',
    debounce(
      function (event) {
        pushToDataLayer("mendel_form", {
          form_of_study: $(this).val(),
          user_hash: userHash,
        });
      },
      false,
      3000
    )
  );

  $document.on("keyup", 'input[name="studyProgram-form"]', function (event) {
    if (event.key === "Enter") {
      pushToDataLayer("mendel_degree", {
        form_of_study: $(this).val(),
        user_hash: userHash,
      });
    }
  });

  // Batch update data layer
  const dataLayerBatchUpdate = () => {
    const degreeElement = document.querySelector(
      'input[name="studyProgram-type"]:checked'
    );
    const languageElement = document.querySelector(
      'input[name="studyProgram-language"]:checked'
    );
    const formElement = document.querySelector(
      'input[name="studyProgram-form"]:checked'
    );
    const searchElement = document.querySelector(
      'input[name="studyProgram-search"]'
    );

    const degree = degreeElement ? degreeElement.value : "";
    const language = languageElement ? languageElement.value : "";
    const formOfStudy = formElement ? formElement.value : "";
    const search = searchElement ? searchElement.value : "";

    pushToDataLayer("mendel_degree", {
      degree: degree,
      user_hash: userHash,
    });
    pushToDataLayer("mendel_language", {
      language: language,
      user_hash: userHash,
    });
    pushToDataLayer("mendel_form", {
      form_of_study: formOfStudy,
      user_hash: userHash,
    });
    pushToDataLayer("mendel_search", {
      keyword: search,
      user_hash: userHash,
    });

  };

  // ========== DATALAYERS END ===========

$(document).on("click", '.study-program-item', function(event) {
    event.preventDefault();
});

$(document).on("mousedown", '.study-program-item', function(event) {
    var $this = $(this);
    var originUrl = new URL($this.attr('href'));
    originUrl.searchParams.delete('rup');
    var href = originUrl.href;
    var url = new URL(window.location);
    var encodeUrl = btoa(url);
    switch (event.which) {
        case 1:
            window.location.href = href + '?rup=' + encodeUrl;
            break;
        case 2:
            window.open(href + '?rup=' + encodeUrl);
            break;
        case 3:
            $this.attr('href', href + '?rup=' + encodeUrl);
            break;
        default:
    }
});

const studyProgramBlock = (tableEl) => {
    filter = {
        lang: tableEl.data('lang'),
        heading: tableEl.data('heading'),
        limit: tableEl.data('limit'),
        selectType: tableEl.data('select-type'),
        startLimit: tableEl.data('start-limit'),
        page: 1,
        search: '',
        type: '',
        language: '',
        form: '',
        area: [],
        faculty: [],
    };

    bindStudyProgram(tableEl, filter);
    bindStudyProgramFilter(tableEl, filter);
};

const reRenderStudyProgram = async (element, filter, append = false) => {
    const blockContent = element.find('.study-program-block__content');
    
    const data = await getStudyProgram(filter);
    if (data != null) {
        if (append) {
            const headings = blockContent.find('.study-program-block__faculty-heading');
            const lastHeadding = headings.last();
            const dataHtml = $(data.html);
            const firstHeading = $(dataHtml[0]);

            const url = new URL(window.location);
            var dataChangeHtml = data.html;
            dataChangeHtml = replaceAll(dataChangeHtml, SITE_PARAMS.api_url + '/en/studijni-programy', url.origin + '/en/studijni-programy');
            dataChangeHtml = replaceAll(dataChangeHtml, SITE_PARAMS.api_url + '/studijni-programy', url.origin + '/studijni-programy');
            blockContent.append(dataChangeHtml);

            const newHeadings = blockContent.find('.study-program-block__faculty-heading');
            var lastElement = null;
            newHeadings.each(function() {
                if ($(this).html() == lastHeadding.html() && $(this).html() == firstHeading.html()) {
                    lastElement = $(this);
                }
            });

            if (lastElement != null) {
                lastElement.remove();
            }
        } else {
            const url = new URL(window.location);
            var dataChangeHtml = data.html;
            dataChangeHtml = replaceAll(dataChangeHtml, SITE_PARAMS.api_url + '/en/studijni-programy', url.origin + '/en/studijni-programy');
            dataChangeHtml = replaceAll(dataChangeHtml, SITE_PARAMS.api_url + '/studijni-programy', url.origin + '/studijni-programy');
            element.find('.study-program-block__content').html(dataChangeHtml);
        }
    }
};

const bindStudyProgram = (element, filter) => {
    element.on('click', '.showMoreButton__item', function () {

        filter.page = $(this).data('page');
        filter.limit = filter.startLimit;
        $(this).parent().remove();
        reRenderStudyProgram(element, filter, true);
        
    });
};

const bindStudyProgramFilter = (element, filter) => {
    element.on('keyup', "input[name='studyProgram-search']", function (ev) {
        delay(function () {
            filter.page = 1;
            filter.limit = filter.startLimit;
            filter.search = element.find("input[name='studyProgram-search']").val();
            const url = new URL(window.location);
            if (filter.search != '') {
                url.searchParams.set('sps', filter.search);
            } else {
                url.searchParams.delete('sps');
            }
            window.history.pushState({}, '', url);
            reRenderStudyProgram(element, filter);

            if (ev.keyCode == 13) {
                smoothscroll($('.study-program-block__content'), 70);
            }
        }, 400);
    });

    element.on('click', "input[name='studyProgram-type']", function () {
        const url = new URL(window.location);
        if ($(this).val() == url.searchParams.get('t')) {
            $(this).prop('checked', false);
            filter.page = 1;
            filter.limit = filter.startLimit;
            filter.type = '';
            url.searchParams.delete('t');
            window.history.pushState({}, '', url);
            reRenderStudyProgram(element, filter);
        }
    });
    element.on('change', "input[name='studyProgram-type']", function () {
        filter.page = 1;
        filter.limit = filter.startLimit;
        filter.type = $(this).val();
        const url = new URL(window.location);
        if (filter.type != '') {
            url.searchParams.set('t', filter.type);
        } else {
            url.searchParams.delete('t');
        }
        window.history.pushState({}, '', url);
        reRenderStudyProgram(element, filter);
    });
    
    element.on('click', "input[name='studyProgram-language']", function () {
        const url = new URL(window.location);
        if ($(this).val() == url.searchParams.get('l')) {
            $(this).prop('checked', false);
            filter.page = 1;
            filter.limit = filter.startLimit;
            filter.language = '';
            url.searchParams.delete('l');
            window.history.pushState({}, '', url);
            reRenderStudyProgram(element, filter);
        }
    });
    element.on('change', "input[name='studyProgram-language']", function () {
        filter.page = 1;
        filter.limit = filter.startLimit;
        filter.language = $(this).val();
        const url = new URL(window.location);
        if (filter.language != '') {
            url.searchParams.set('l', filter.language);
        } else {
            url.searchParams.delete('l');
        }
        window.history.pushState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('click', "input[name='studyProgram-form']", function () {
        const url = new URL(window.location);
        if ($(this).val() == url.searchParams.get('f')) {
            $(this).prop('checked', false);
            filter.page = 1;
            filter.limit = filter.startLimit;
            filter.form = '';
            url.searchParams.delete('f');
            window.history.pushState({}, '', url);
            reRenderStudyProgram(element, filter);
        }
    });
    element.on('change', "input[name='studyProgram-form']", function () {
        filter.page = 1;
        filter.limit = filter.startLimit;
        filter.form = $(this).val();
        const url = new URL(window.location);
        if (filter.form != '') {
            url.searchParams.set('f', filter.form);
        } else {
            url.searchParams.delete('f');
        }
        window.history.pushState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('change', "select[name='studyProgram-area']", function () {
        filter.page = 1;
        filter.limit = filter.startLimit;
        filter.area = $(this).val();
        const url = new URL(window.location);
        if (filter.area != '') {
            url.searchParams.set('ai', filter.area);
        } else {
            url.searchParams.delete('ai');
        }
        window.history.pushState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('change', "select[name='studyProgram-faculty']", function () {
        filter.page = 1;
        filter.limit = filter.startLimit;
        filter.faculty = $(this).val();
        const url = new URL(window.location);
        if (filter.faculty != '') {
            url.searchParams.set('fi', filter.faculty);
        } else {
            url.searchParams.delete('fi');
        }
        window.history.pushState({}, '', url);
        reRenderStudyProgram(element, filter);
    });

    element.on('click', "button[name='search-study-program-filter']", function () {
        filter.page = 1;
        filter.limit = filter.startLimit;
        const $thisEl = $(this);
        const parent = $thisEl.parent().parent();
        filter.search = parent.find("input[name='studyProgram-search']").val();
        filter.type = parent.find("input[name='studyProgram-type']:checked").val();
        filter.language = parent.find("input[name='studyProgram-language']:checked").val();
        filter.form = parent.find("input[name='studyProgram-form']:checked").val();
        filter.area = parent.find("select[name='studyProgram-area']").val();
        filter.faculty = parent.find("select[name='studyProgram-faculty']").val();

        reRenderStudyProgram(element, filter);

        dataLayerBatchUpdate();
    });

    element.on('click', "button[name='remove-study-program-filter']", function () {

        filter.page = 1;
        filter.limit = filter.startLimit;
        filter.search = '';
        filter.type = "";
        filter.language = '';
        filter.form = '';

        const $thisEl = $(this);
        const parent = $thisEl.parent().parent();
        parent.find("input[name='studyProgram-search']").val('');
        parent.find("input[name='studyProgram-type']").prop("checked", false);
        parent.find("input[name='studyProgram-language']").prop('checked', false);
        parent.find("input[name='studyProgram-form']").prop('checked', false);

        const url = new URL(window.location);
        url.searchParams.delete('sps');
        url.searchParams.delete("t");
        url.searchParams.delete('l');
        url.searchParams.delete('f');
        window.history.pushState({}, '', url);

        element.find('.study-program-block__content').html('');

        dataLayerBatchUpdate();
    });
};

const getStudyProgram = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.api_url + `/wp-json/mendelu/v1/study-program-block/html`, {
            method: 'POST',
            mode: 'cors',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        let result = {};
        result.html = '';
        console.log(e);
        return result;
    }
};

const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

export function renderStudyProgram() {

    const element = $('.study-program-block__container');
    filter.page = 1;
    filter.limit = 3;
    const $thisEl = element;
    const parent = $thisEl.parent().parent();

    const url = new URL(window.location);
    
    let selectType = url.searchParams.get('t');
    if (selectType != '') {
        let typeObject = parent.find("input[value='" + selectType + "']");
        typeObject.prop('checked', true);
        typeObject.val(selectType);
        filter.type = selectType;
    }

    let search = url.searchParams.get('sps');
    if (search != '') {
        let searchObject = parent.find("input[name='studyProgram-search']");
        searchObject.val(search);
        filter.search = search;
    }

    let language = url.searchParams.get('l');
    if (language != '') {
        let languageObject = parent.find("input[value='" + language + "']");
        languageObject.prop('checked', true);
        languageObject.val(language);
        filter.language = language;
    }

    let form = url.searchParams.get('f');
    if (form != '') {
        let formObject = parent.find("input[value='" + form + "']");
        formObject.prop('checked', true)
        formObject.val(form);
        filter.form = form;
    }

    const isHideFilter = parent.find(".study-program-block-main").data('hide-filter');
    if (! isHideFilter) {
        let facultyObject = parent.find("select[name='studyProgram-faculty']");
        facultyObject.parent().parent().parent().css('display', 'none');
        filter.faculty = facultyObject.val();
    } else {
        filter.faculty = [];
        filter.faculty.push(parent.find(".study-program-block-main").data('faculty'));
    }

    reRenderStudyProgram(element, filter);
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}